<template>
    <div class="report-negative">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">

                </div>
                <div class="button-group">
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>

            </div>

            <div class="table-content">
                <el-table class="table-head" :data="negativedata" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="title" label="名称" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="ccode" label="集中器编码" min-width="80"></el-table-column>
                    <el-table-column align="center" prop="pcode" label="设备编码" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="mode" label="模式" min-width="50"></el-table-column>
                    <el-table-column align="center" prop="devno" label="设备属性" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="stay" label="房源状态" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="status" label="设备状态" min-width="70"></el-table-column>
                    <el-table-column align="center" prop="addr" label="地址" min-width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="time" label="时间" min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="staydate" label="操作" min-width="50">
                        <template slot-scope="scope">
                            <el-button @click="toHouse(scope.$index, negativedata)" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

        </div>
    </div>
</template>

<script>
    import store from "../store";
    var FileSaver = require('file-saver');

    export default {
        name: "ReportNegative",
        data() {
            return{
                negativedata:[],

            }
        },
        mounted(){
            this.Negativedata();
        },
        methods:{
            Negativedata(){
                this.$http.get(`${store.state.url}report/negativedevice/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        if (res.Code == 0) {
                            let negativedata = [];
                            if(res.Data!=null) {
                                for (let i in res.Data) {
                                    let mode, devno, stay, status;
                                    if (res.Data[i].Param.mode == 0) {
                                        mode = '后付'
                                    } else if (res.Data[i].Param.mode == 1) {
                                        mode = '预付'
                                    } else {
                                        mode = '未知'
                                    }

                                    if (res.Data[i].Devno == 9) {
                                        if (res.Data[i].Virtual == 1) {
                                            devno = '虚拟电表';
                                        } else if (res.Data[i].Virtual == 2) {
                                            devno = '被虚拟节点';
                                        } else {
                                            devno = '个人房间';
                                        }
                                    } else if (res.Data[i].Devno == 11) {
                                        devno = "独立";
                                    } else if (res.Data[i].Devno == 13) {
                                        devno = "总公";
                                    } else {
                                        devno = "-";
                                    }

                                    if (res.Data[i].Devno == 9 && res.Data[i].Virtual != 2 && res.Data[i].External != undefined) {
                                        if (res.Data[i].External.stay != undefined) {
                                            if (res.Data[i].External.stay) {
                                                stay = '入住';
                                            } else {
                                                stay = '空置';
                                            }
                                        }

                                    } else {
                                        stay = "-";
                                    }

                                    if (res.Data[i].Status == 0) {
                                        status = "在线";
                                    }
                                    else if (res.Data[i].Status == 1) {
                                        status = "离线";
                                    }

                                    negativedata[i] = {
                                        title: res.Data[i].Title,
                                        ccode: res.Data[i].Ccode,
                                        pcode: res.Data[i].Pcode,
                                        mode: mode,
                                        devno: devno,
                                        stay: stay,
                                        status: status,
                                        addr: res.Data[i].Addr,
                                        time: res.Data[i].Expand.lasttime.time.replace("T", " ").replace("+08:00", " ").replace(/\.[0-9]{1,4}/, ""),
                                        devid: res.Data[i].Uuid,
                                    }
                                }
                            }
                            this.negativedata = negativedata;
                        }else {
                            this.negativedata =[];
                            this.$message(res.Message);
                        }
                    })
            },

            //导出excel
            downloadMater() {
                const defaultCellStyle = {
                    font: {name: "Verdana", sz: 11, color: "FF00FF88"},
                    fill: {fgColor: {rgb: "FFFFAA00"}}
                };
                const wopts = {
                    bookType: 'xlsx',
                    bookSST: false,
                    type: 'binary',
                    defaultCellStyle: defaultCellStyle,
                    showGridLines: false
                };
                const wb = {SheetNames: ['Sheet1'], Sheets: {}, Props: {}};

                let Data = [];
                for (let i in this.negativedata) {
                    Data[i] = {
                        名称: this.negativedata[i].title,
                        集中器编码: this.negativedata[i].ccode,
                        设备编码: this.negativedata[i].pcode,
                        模式: this.negativedata[i].mode,
                        设备属性: this.negativedata[i].devno,
                        房源状态: this.negativedata[i].stay,
                        设备状态: this.negativedata[i].status,
                        地址: this.negativedata[i].addr,
                        时间: this.negativedata[i].time,

                    };
                }
                let data = Data;
                wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                //创建二进制对象写入转换好的字节流
                let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {type: "application/octet-stream"})
                FileSaver.saveAs(tmpDown, "公摊为负数报表.xls");
            },
            //字符串转字符流
            s2ab(s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },
            toHouse(index, row) {
                let devid = row[index].devid,
                    tableInfo = {};
                window.localStorage.devid = devid;
                tableInfo.table = 1;
                tableInfo.index = '3';
                store.commit('assignReportPreTableTab', tableInfo);
                this.$router.push('./house');
            }
        }
    }
</script>

<style scoped>
    .select-search {
        margin: 0 0.2rem 0.2rem 0;
    }

</style>